import React from 'react';
import { render } from 'react-dom';

import Search from '../react/Search';

export default class SearchRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model } = this.context.dataset;
    if (!apiUrl || !model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<Search {...jsonModel} apiURL={apiUrl} />, this.context);
  }
}
